import { Module } from 'vuex-smart-module';
import ReportsRepairsActions from './actions';
import ReportsRepairsGetters from './getters';
import ReportsRepairsMutations from './mutations';
import ReportsRepairsState from './state';

export default new Module({
  state: ReportsRepairsState,
  mutations: ReportsRepairsMutations,
  actions: ReportsRepairsActions,
  getters: ReportsRepairsGetters,
});
